/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { validateQuestion } from "./validate-question";

/** @param {GroupQuestion} question */
export const validateGroupQuestion = (question) => {
    const errors = question?.questions?.flatMap(validateQuestion).filter(Boolean);
    const errorsWithGroupPrexix = errors.map((error) => `In group "${question?.key || question?.prompt || question?.type}": ${error}`);
    return errorsWithGroupPrexix || [];
};
